import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FormattedWeight } from '../../../components/formatted-weight';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const WeightColumnContainer = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { packages } =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'labelConfiguration',
      }),
    ) ?? {};

  const { weight } = packages?.[0] ?? {};

  if (!weight) {
    return '';
  }

  return <FormattedWeight weight={weight} />;
};

WeightColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Weight = {
  getMessageDescriptor: () => messages.weight,
  id: 'weight',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <WeightColumnContainer fulfillmentId={data.id} />;
  },
};
